import LockSimpleButton from './LockSimpleButton';

export default LockSimpleButton;